import { useRef, useCallback } from 'react';

export interface GlassHoverState {
  mouseX: number;
  mouseY: number;
  hover: boolean;
}

export function useGlassHover() {
  const stateRef = useRef<GlassHoverState>({
    mouseX: 0.5,
    mouseY: 0.5,
    hover: false,
  });

  const lastMoveRef = useRef(0);
  const THROTTLE_MS = 16; // ~60fps mouse tracking for smooth specular

  const onMouseMove = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const now = performance.now();
    if (now - lastMoveRef.current < THROTTLE_MS) return;
    lastMoveRef.current = now;

    const rect = e.currentTarget.getBoundingClientRect();
    stateRef.current.mouseX = (e.clientX - rect.left) / rect.width;
    stateRef.current.mouseY = 1.0 - (e.clientY - rect.top) / rect.height;
    stateRef.current.hover = true;
  }, []);

  const onMouseLeave = useCallback(() => {
    stateRef.current.hover = false;
  }, []);

  return {
    stateRef,
    handlers: { onMouseMove, onMouseLeave },
  };
}
